import React from "react"

interface DebugSampleFilterProps {
  debugSample: boolean | undefined
  onDebugSampleChange: (value: boolean | undefined) => void
}

export const DebugSampleFilter: React.FC<DebugSampleFilterProps> = ({ debugSample, onDebugSampleChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value
    if (val === "true") onDebugSampleChange(true)
    else if (val === "false") onDebugSampleChange(false)
    else onDebugSampleChange(undefined)
  }

  const selectValue = debugSample === true ? "true" : debugSample === false ? "false" : ""

  return (
    <div className="form-control flex-1 max-w-xs">
      <label htmlFor="debugSample" className="label">
        <span className="label-text">Тестовая выборка</span>
      </label>
      <select
        id="debugSample"
        name="debugSample"
        className="select select-bordered"
        value={selectValue}
        onChange={handleChange}
      >
        <option value="">Все</option>
        <option value="true">Только тестовые</option>
        <option value="false">Без тестовых</option>
      </select>
    </div>
  )
}
